export default __webpack_public_path__ + "static/media/menu-m@3x.cb1e1604.png";